import { style } from '@vanilla-extract/css'

export const layoutWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  minHeight: ['100vh', '100svh'],
})
